import type { ComponentProps } from 'react'
import PFASEligibilityDetails from '../components/PFASEligibilityDetails'

type Props = ComponentProps<typeof PFASEligibilityDetails>

export default function Step2_EligibilityDetails(props: Props) {
  return <PFASEligibilityDetails {...props} />
}

